module.exports = __webpack_public_path__ + "img/nosotros_01-conocimiento-para-que-tomes-decisiones.2550f970.jpg";